
import { defineComponent } from "vue";
import { ISystemAreasModel } from "@/interfaces/modules";
import SystemAreasService from "@/api/Academic/SystemAreasService.ts";
import store from "@/store";

export default defineComponent({
  name: "SystemAreasContent",
  data() {
    return {
      form: {
        dialog: false,
        record: {} as ISystemAreasModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Code", label: "Código", sortable: true },
          { key: "Name", label: "Nombre", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Status", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ISystemAreasModel[],
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    filteredItems(): ISystemAreasModel[] {
      const search = this.table.filters.search.toLowerCase();
      return this.table.filters.search
        ? this.table.records.filter(
          (item) =>
            item.Name?.toLowerCase().includes(search) ||
            item.Code?.toLowerCase().includes(search) ||
            item.Description?.toLowerCase().includes(search)
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records.length;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await SystemAreasService.GetAreas();
      this.table.loading = false;
    },
    async edit(item: ISystemAreasModel) {
      this.form.record = await SystemAreasService.GetAreaById(item);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as ISystemAreasModel;
      this.form.dialog = true;
    },
    async handleSubmit() {
      this.form.dialog = false;
      await SystemAreasService.PostArea(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
